export default "__VITE_ASSET__th8iRjCf__"